import React, {forwardRef, useState} from 'react';
import {Box, Input, Icon} from '@spothero/ui';
import IconCalendar from '@spothero/icons/calendar';
import {PropTypes} from 'prop-types';
import {v4 as uuidV4} from 'uuid';
import dayjs from 'dayjs';

const DatePickerInput = forwardRef(
    ({openDatePicker, selectedDate, disabled, labelText}, ref) => {
        // In DatePicker we check the id of an outside click to not close the modal if what they clicked was the input
        // When two+ datepickers on screen at once though, need a way to differentiate, hence this unique id
        const [uniqueId] = useState(uuidV4());

        return (
            <Box position="relative" paddingX="unset" width="100%">
                <Input
                    disabled={disabled}
                    aria-label="multi-select-datepicker-input"
                    fontWeight="semibold"
                    onClick={openDatePicker}
                    isReadOnly
                    ref={ref}
                    value={dayjs(selectedDate).format('ddd, MMM D')}
                    cursor="default"
                    id={`multi-select-datepicker-input-${uniqueId}`}
                    label={labelText}
                    data-testid="DatePicker-input"
                />
                {/* this implementation is required in order to circumvent the older version of the FE-UI */}
                <Icon
                    as={IconCalendar}
                    position="absolute"
                    top={10}
                    right={2}
                    pointerEvents="none"
                />
            </Box>
        );
    }
);

DatePickerInput.propTypes = {
    openDatePicker: PropTypes.func,
    selectedDate: PropTypes.string,
    disabled: PropTypes.bool,
    labelText: PropTypes.string,
};

export default DatePickerInput;
